<div *ngIf="isLoading; else hierarchyChunk">
  <span class="right-component-header">
    <span>{{ label }} (0)</span>
  </span>
  <app-progress [short]="true"></app-progress>
</div>
<ng-template #hierarchyChunk>
  <div ngbAccordion #accordion="ngbAccordion">
    <div ngbAccordionItem="hierarchy" #hierarchy="ngbAccordionItem" [collapsed]="isCollapsed">
      <span class="right-component-header" [ngClass]="{ 'default-pointer': treePositionsList?.length > 0, 'pagination-mod': !hierarchy.collapsed }">
        <span *ngIf="treePositionsList?.length !== 0" ngbAccordionToggle
          >{{ label }} ({{ page >= totalTreePositions ? totalTreePositions : (page - 1) * perPage + 1 }} to
          {{ page * perPage >= totalTreePositions ? totalTreePositions : page * perPage }} of {{ totalTreePositions || 0 }})
        </span>
        <span *ngIf="treePositionsList?.length === 0">{{ isLoading ? label + '(Loading..)' : label + '(0)' }}</span>
        <div *ngIf="!hierarchy.collapsed" class="d-flex d-print-none">
          <app-table-pagination
            *ngIf="totalTreePositions > 5"
            class="chunk-pagination"
            [page]="page"
            [perPage]="perPage"
            [perPageValue]="perPageValue"
            [collectionSize]="totalTreePositions"
            (pageChange)="onPageChange($event)"
            (perPageValueChange)="selectPaginationLimit($event)"
            [smallerSize]="true"
          ></app-table-pagination>
        </div>
      </span>
      <span
        ngbAccordionToggle
        *ngIf="hierarchy.collapsed && treePositionsList?.length !== 0"
        title="Expand Section"
        class="icon-color float-right pt-1"
        ><i class="fas fa-plus"></i
      ></span>
      <span
        ngbAccordionToggle
        *ngIf="!hierarchy.collapsed && treePositionsList?.length !== 0"
        title="Collapse Section"
        class="icon-color float-right pt-1"
        ><i class="fas fa-minus"></i
      ></span>
      <a
        (click)="openModal()"
        *ngIf="treePositionsList?.length !== 0"
        class="json-link mr-2 default-pointer float-right pt-1"
        title="Show JSON for concept tree"
        ><i class="fas fa-code"></i
      ></a>

      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            <div class="hierarchy-chunk-div">
              <table class="table hierarchy-chunk-container">
                <tbody>
                  <ng-container *ngIf="showChunk">
                    <tr *ngIf="treePositionsList?.length > 1">
                      <th (click)="sort('concept')" *ngIf="!isInverse" class="relationship-chunk-border-top" title="Concept">
                        Path
                        <span *ngIf="sortField === 'concept' && !ascending" class="sort-indicator transform-0">▾</span>
                        <span *ngIf="sortField === 'concept' && ascending" class="sort-indicator transform-180">▾</span>
                      </th>
                    </tr>
                    <tr
                      *ngFor="let treePosition of treePositionsList; let i = index"
                      [class.hierarchy-active]="treePosition[0] === activeTreePosition && treePositionsList.length > 1"
                    >
                      <td (click)="setActiveTreePosition(i)" class="hierarchy-chunk-border">
                        <span class="default-pointer w-container">{{ (page - 1) * perPage + i + 1 }}. </span>
                        <ng-container *ngFor="let concept of treePosition[1]; let last = last">
                          <span *ngIf="!last" class="concept-link" (dblclick)="goToConcept(concept)">{{ concept?.name }}</span>
                          <span *ngIf="last" class="default-pointer">{{ concept?.name }}</span>
                          <span *ngIf="!last" class="default-pointer"> > </span>
                        </ng-container>
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>

            <app-hierarchy-tree
              [currentProject]="currentProject"
              [currentOrgUriLabel]="currentOrgUriLabel"
              [selectedConcept]="selectedConcept"
              [terminologies]="terminologies"
              [data]="treeData"
              (onClick)="goToConcept($event)"
              (onChange)="onChange($event)"
            >
            </app-hierarchy-tree>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<app-th-modal
  title="JSON for Concept"
  [openModal]="isModalOpen"
  (modalClosed)="handleModalClosed()"
  [selectedConcept]="treePositionsList"
></app-th-modal>
